import { memo, useCallback, useEffect, useState } from "react";

import styled from "styled-components";
import { queryToPredicates } from "utils/filter";

import { generateFilterQuery } from "api/filter";

import { BaseTree } from "components/base";

import { usePropertyTitleLookup, useShapefileBufferLabelUnit } from "./hooks";

const emptyPredicate = {
  id: "",
  title: "",
  name: "",
  children: [],
  expanded: false,
  operator: "",
  type: "",
  isChecked: false
};

const clearedFilterPredicate = [
  {
    id: "a960d35d702a58",
    title: "and",
    displayTitle: "",
    name: "Active",
    expanded: true,
    count: 0,
    operator: "and",
    children: [
      {
        id: "e5e780618455a",
        title: "Polygon = Map View",
        displayTitle: "Polygon = Map View",
        name: "Polygon = Map View",
        expanded: true,
        children: [],
        count: 0,
        type: "",
        isChecked: false
      }
    ],
    type: "",
    isChecked: false
  }
];

function SavedFilterDetails({ filter }) {
  const [predicates, setPredicates] = useState([emptyPredicate]);

  const propertyTitleLookup = usePropertyTitleLookup();
  // A saved filter's buffer is spelled in the unit whoever opened it works in,
  // so the same saved filter reads "(+5 km)" for one person and "(+3.11 mi)"
  // for another.
  const bufferLabelUnit = useShapefileBufferLabelUnit();

  useEffect(() => {
    if (!filter) return;
    if (
      (!filter.wellListFilter || filter.wellListFilter.length === 0) &&
      (!filter.polygonFilter || filter.polygonFilter.length === 0) &&
      (!filter.excludePolygonsFilter || filter.excludePolygonsFilter.length === 0) &&
      (!filter.propertiesFilter || filter.propertiesFilter.length === 0)
    ) {
      setPredicates(clearedFilterPredicate);
      return;
    }
    const query = generateFilterQuery(
      filter.wellListFilter,
      filter.polygonFilter,
      filter.excludePolygonsFilter,
      filter.propertiesFilter,
      null,
      null,
      filter.entityKind
    );
    const predicate = queryToPredicates(
      query.query,
      [],
      propertyTitleLookup,
      bufferLabelUnit
    );
    setPredicates([predicate]);
  }, [filter, propertyTitleLookup, bufferLabelUnit]);

  const itemTemplate = useCallback(({ node, depth }) => {
    const nodeTitle = node.displayTitle || node.name.split(" ").slice(1).join(" ");
    return (
      <div className={`item-template leaf`}>
        <div
          title={node.title}
          style={{
            color: `${node.operator === "nin" ? "#ff2855" : ""}`
          }}
          className={`label depth-${depth}`}>
          {nodeTitle}
        </div>
      </div>
    );
  }, []);

  const nodeTemplate = useCallback(
    ({ node }) => (
      <div className="item-template node">
        <div
          style={{
            maxWidth: `100%`,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis"
          }}>
          {node.name}
        </div>
      </div>
    ),
    []
  );

  return (
    <Wrapper className={"predicate-tree"}>
      <BaseTree
        nodes={predicates}
        nodeTemplate={nodeTemplate}
        itemTemplate={itemTemplate}
      />
    </Wrapper>
  );
}

export default memo(SavedFilterDetails);

const Wrapper = styled.div`
  margin: 0;
`;
